var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-item',{staticClass:"my-account-menu",attrs:{"link":"","to":item.url}},[_c('v-list-item-title',[_vm._v(_vm._s(item.label))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }